module.exports = __webpack_public_path__ + "static/media/download-icon.752c496d.svg";